import { CategoryDataType } from '../filters';
import { ITeamableMongooseModel } from './interface/mongoose.repository';

export interface IProject extends ITeamableMongooseModel {
  _id: string;
  name: string;
  usersCount: number;
  usersSentCount: number;
  usersRepliedCount: number;
  isArchived: boolean;
  description: string;
  parentProject: string | IProject;
  savedTabs: (string | IProject)[];

  status: EProjectStatus;

  criteriaDetails?: {
    candidateLimit: number;
    useSubscriptionLimit: boolean;
    dbOnlyCandidates: boolean;
    filters: string | CategoryDataType[]; //db will store stringified version
  };

  signalsEnabled: boolean;

  updatedAt: string;
  createdAt: string;
}

export enum EProjectStatus {
  PENDING = 'Pending',
  DONE = 'Done',
  ARCHIVED = 'Archived',
  CHECKING = 'Checking',
  FROM_FILE = 'From File'
}
